import React from 'react';
import propTypes from './propTypes';

const AboutNotes = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 7V9H8V7H16Z" fill="currentColor" />
    <path d="M13 13H8V11H13V13Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M12 1C7.03242 1 3 5.01514 3 9.97472C3 13.9088 5.53708 17.2471 9.0633 18.4605C9.36486 18.9678 9.8216 19.6422 10.2093 20.2014C10.4681 20.5747 10.7131 20.9207 10.8932 21.1731C10.9833 21.2994 11.0573 21.4025 11.109 21.4742L11.1689 21.5573L11.1905 21.5871L11.9997 22.7026L12.8097 21.5869L12.8308 21.5577L12.8907 21.4748C12.9422 21.4032 13.0162 21.3003 13.1062 21.1742C13.2861 20.9223 13.5308 20.5769 13.7894 20.2039C14.1774 19.6445 14.6346 18.9694 14.9369 18.4604C18.463 17.2469 21 13.9087 21 9.97472C21 5.01514 16.9676 1 12 1ZM12.1459 19.0642C12.0968 19.1352 12.0481 19.2051 12.0002 19.2736C11.9519 19.2044 11.9026 19.1336 11.8529 19.0619C11.3283 18.3051 10.8112 17.5261 10.6373 17.1794L10.4421 16.7902L10.0242 16.668C7.11757 15.8177 5 13.14 5 9.97472C5 6.12567 8.13102 3 12 3C15.869 3 19 6.12567 19 9.97472C19 13.14 16.8824 15.8177 13.9758 16.668L13.5579 16.7902L13.3627 17.1794C13.1872 17.5294 12.6699 18.3086 12.1459 19.0642Z" fill="currentColor" />
  </svg>
);

AboutNotes.propTypes = propTypes;

export default AboutNotes;
